'use strict';

angular.module('supervisorAuthorizingUserRequestRoutes', ['supervisorAuthorizingUserRequestControllers',
                                                          'services.supervisorService',
                                                          'services.authenticatedUser'])

.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('supervisorAuthorizingUserRequest', {
            url: '/supervisor/authorizingUserRequest',
            templateUrl: require('./MainSupervisorAuthorizing.tpl.html'),
            controller: 'MainSupervisorAuthorizingController',
            resolve: {
                userRequestsToAuthorize: ['supervisorService', function (service) {
                    return service.getUserRequestsToAuthorize();
                }]
            }
        })

        .state('supervisorAuthorizingUserRequest_ByRequest', {
            abstract: true,
            url: '/supervisor/authorizingUserRequest/{userAccessRequestId:int}',
            template: '<div ui-view/>',
            resolve: {
                userRequestToAuthorize: ['$stateParams', 'supervisorAuthorizingUserRequestService', function ($stateParams, service) {
                    return service.getUserRequestToAuthorize($stateParams.userAccessRequestId);
                }],

                employee: ['employeeService', function (service) {
                  return service.getEmployeeIDByAuthentication();
                }]
            }
        })

        .state('supervisorAuthorizingUserRequest_ByRequest.View', {
            url: '',
            templateUrl: require('./SupervisorAuthorizingRequest_View.tpl.html'),
            controller: 'SupervisorAuthorizingRequestController'
        })

        .state('supervisorAuthorizingUserRequest_ByRequest.Authorize', {
            url: '/authorize',
            templateUrl: require('./SupervisorAuthorizingRequest_Authorize.tpl.html'),
            controller: 'SupervisorAuthorizingRequestController'
        })

        .state('supervisorAuthorizingUserRequest_ByRequest.NotAuthorizable', {
            url: '/notAuthorizable',
            templateUrl: require('./NotAuthorizable.tpl.html'),
            controller: 'NotAvailableController'
        })

        .state('supervisorAuthorizingUserRequest_ByRequest.NotAvailable', {
            url: '/notAvailable',
            templateUrl: require('./NotAvailable.tpl.html'),
            controller: 'NotAvailableController'
        })

        .state('supervisorAuthorizingUserRequest_ByRequest.NotSupervisor', {
            url: '/notSupervisor',
            templateUrl: require('./NotSupervisor.tpl.html'),
            controller: 'NotAvailableController'
        })

        .state('supervisorAuthorizingUserRequest_ByRequest.SelfRequestAsDelegate', {
          url: '/selfRequestAsDelegate',
          templateUrl: require('./SelfRequestAsDelegate.tpl.html'),
          controller: 'NotAvailableController'
        });
}]);
